import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import dessertImg from "@/assets/dessert.webp";
import spaHeroImg from "@/assets/spa-hero.webp";
import impalaImg from "@/assets/impala.webp";

const experiences = [
  {
    image: dessertImg,
    title: "Culinary Safari",
    desc: "Explore masterful cuisine inspired by African flavours yet guided by the Western culinary tradition.",
    to: "/culinary",
    cta: "Discover Safari Boma Dining",
  },
  {
    image: spaHeroImg,
    title: "African Spa",
    desc: "Revive Body, Mind & Soul.",
    to: "/spa",
    cta: "Explore the African Bushveld Spa",
  },
  {
    image: impalaImg,
    title: "Wildlife Safaris",
    desc: "Embark on unforgettable wildlife safaris and game drives led by experienced guides on a malaria-free private reserve.",
    to: "/experiences",
    cta: "See Our Wildlife Safaris",
  },
];

const ExperiencesSection = () => {
  return (
    <section id="experiences" className="bg-lodge-deep py-4 sm:py-6 lg:py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-heading text-2xl md:text-4xl tracking-wider text-foreground text-center mb-3">
          UNFORGETTABLE MOMENTS
        </h2>
        <p className="text-sm text-muted-foreground text-center mb-12 max-w-2xl mx-auto italic">
          From game drives & guided walks to indulgent spa treatments & private
          bushveld picnics, every experience at Zwahili is crafted to inspire
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {experiences.map((exp) => (
            <Link
              key={exp.title}
              to={exp.to}
              aria-label={exp.cta}
              className="group bg-card border border-border rounded overflow-hidden hover:border-gold/30 transition-colors"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={exp.image}
                  alt={`${exp.title} at Zwahili Private Game Lodge in Limpopo`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-6">
                <h3 className="font-heading text-xl text-foreground mb-2">
                  {exp.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed mb-4">
                  {exp.desc}
                </p>
                <span className="inline-flex items-center gap-2 text-xs text-gold tracking-widest uppercase font-body group-hover:gap-3 transition-all">
                  {exp.cta} <ArrowRight size={14} />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperiencesSection;
